import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2b2733f9"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=2b2733f9&prod&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=2b2733f9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports